import { createAction, props } from '@ngrx/store';

import {
  CitationModel,
  NumberedCitation,
  ReferenceEditor,
  UnnumberedCitation,
  ITrackChange,
  ChevronData,
  FragmentLink,
} from '../models/decorators.model';
import { WkTemplate } from '../../../model/wk-template-model';
import { DocumentValidationStatus } from '../../../model/validation-service.model';

export const setOrderedCitationIds = createAction(
  '[ Citation reorder ] updated reordered citation ids',
  props<{
    ids: string[];
  }>()
);

export const initDecoratorsLoading = createAction(
  '[Citations/Keywords/API] Loading start Documents Decorators'
);

export const loadingAllDecorators = createAction(
  '[Citations/Keywords/API] Loading Documents Decorators',
  props<{ nodeId?: string }>()
);

export const setEditorDependency = createAction(
  '[Citations] Setting Editors Dependencies'
);

export const loadAllDecoratorsCompleted = createAction(
  '[Citations/Keywords/API] Load Documents Decorators Completed',
  props<{
    citations: CitationModel;
    documentContent: string | null;
    trackChangeData: ITrackChange;
    subTemplates: WkTemplate[];
    keywords: any[];
  }>()
);

export const initUserInfoFetch = createAction(
  '[UserInfo] Loading start Documents UserInfo',
  props<{ ids: string[] }>()
);

export const loadingAllDecoratorsFailed = createAction(
  '[Citations/Keywords/API] Loading Documents Decorators Failed'
);

export const updateCitations = createAction(
  '[Citations] Update Document Citations',
  props<{ citations: CitationModel }>()
);

export const setCurrentDocumentId = createAction(
  '[Citations/Keywords/API] Set Current Document ID',
  props<{ nodeId?: string }>()
);

export const DOWNLOAD_VALIDATION_LIST = 'DOWNLOAD_VALIDATION_LIST';

export const downloadValidationList = createAction(DOWNLOAD_VALIDATION_LIST);

export const setKeywordIdForCopy = createAction(
  '[Citations] Set Keyword for copy & labelId',
  props<{ keywordId: string; labelId: string }>()
);

export const setCitationsPrefix = createAction(
  '[Citations] Set Citations Prefix counter',
  props<{
    referencePrefix: 'number' | 'roman' | 'alphabet';
    prefix?: string;
    sufix?: string;
    counterCase?: string;
    unnumberReferencePrefix: 'bullet' | 'circle' | 'dash';
  }>()
);

export const setCreatedReferenceId = createAction(
  '[Citations] Set Created Reference ID',
  props<{ referenceId: string }>()
);

export const setEditorToggleTrackChange = createAction(
  '[Citations] Set Righthand Panel Track Changes Enabled',
  props<{ rhpTrackChangesEnabled: boolean }>()
);

export const updateUnnumberedReferences = createAction(
  '[Citations] Update Unnumbered References',
  props<{ references: UnnumberedCitation[] }>()
);

export const updateNumberedReferences = createAction(
  '[Citations] Update Numbered References',
  props<{ references: NumberedCitation[] }>()
);

export const updateNumberedReferencesFromService = createAction(
  '[Citations] Update Numbered References From Service',
  props<{ references: NumberedCitation[] }>()
);

export const updateNumberedReferencesWithoutUndo = createAction(
  '[Citations] Update Numbered References without undo',
  props<{ references: NumberedCitation[] }>()
);

export const setIsEditable = createAction(
  '[Citations/Keywords] Set Editor Editable',
  props<{ isEditable: boolean }>()
);

export const setDeletedUnnumberedReferenceId = createAction(
  '[Citations] Delete Unnumbered Reference',
  props<{ citationId: string | null }>()
);

export const setDeletedNumberedReferenceId = createAction(
  '[Citations] Delete Numbered Reference',
  props<{ citationId: string }>()
);

export const setCitationUpdated = createAction(
  '[Citations] Set citation updated',
  props<{ isCitationUpdated: boolean }>()
);

export const setSelectedCitationId = createAction(
  '[Citations] Set Selected Citation ID',
  props<{ citationId: string }>()
);

export const setCopiedNumberedCitationId = createAction(
  '[Citations] Set copied citation',
  props<{ copiedNumberedCitationId: string }>()
);

export const setReferenceEditorClicked = createAction(
  '[Citations] Set Reference Editor',
  props<{ referenceEditor: ReferenceEditor }>()
);

export const setCopyEnable = createAction(
  '[Citation/Keyword] Set Copy button Enable',
  props<{ isCopyEnable: boolean }>()
);

export const setSelectedReferenceId = createAction(
  '[Citations] Set selected reference Id',
  props<{ id: string }>()
);

export const undoCitations = createAction(
  '[Citations] Undo',
  props<{
    citations: {
      references: NumberedCitation[];
    };
  }>()
);

export const setDeletedFromDocNumberedReferenceId = createAction(
  '[Citations] Delete Numbered Reference From Document',
  props<{ citationId: string; citationCount?: string }>()
);

export const setTrackchangeAndSuggestion = createAction(
  '[Trackchange & Suggestion] Set Document Trackchange & Suggestion',
  props<{
    trackChangeData: ITrackChange;
  }>()
);

export const onLoadingReadonlyContent = createAction(
  '[Split Mode On/Read Only] Loading meta deta on split mode',
  props<{ id: string; url: string }>()
);

export const onLoadCompleteReadonlyContent = createAction(
  '[Split Mode On/Read Only] Loading Completed On split mode',
  props<{
    trackChangeData: ITrackChange;
    docContent: string;
    loaded: boolean;
    citations: CitationModel;
  }>()
);

export const setSelectedChevronData = createAction(
  '[Citations] Set selected chevron data',
  props<{ chevronData: ChevronData }>()
);

export const setInitialReadonlyStore = createAction(
  '[Citation] Reset Decorator State'
);

export const updateUnNumberedReferencesWithoutUndo = createAction(
  '[Citations] UnnumberedReferences Edit',
  props<{ references: UnnumberedCitation[] }>()
);

export const setUnNumUndoRef = createAction(
  '[Citation] set Unumbered Undo Reference',
  props<{ references: UnnumberedCitation[] }>()
);

export const setCitationTabIndex = createAction(
  '[Citation] Set Citation tab index',
  props<{ index: number }>()
);

export const setIsInfoDrawerToggled = createAction(
  '[Citations] Set Info drawer toggled',
  props<{ isInfoDrawerToggled: boolean }>()
);

export const setCiationsUndoStackIndex = createAction(
  '[Citation] set citation undo stack index',
  props<{ unNumRefUndoStackIndex: number; undoStackIndex: number }>()
);

export const setFragmentLinks = createAction(
  '[FragmentLink] Set Fragment Link',
  props<{
    fragmentLinks: {
      incomingLinks: FragmentLink[];
      outgoingLinks: FragmentLink[];
    };
  }>()
);

export const setRHPTrackChangesData = createAction(
  '[Citations] Set TrackChanges for Right Hand Editor',
  props<{ trackChangeRHPData: ITrackChange }>()
);

export const setDeletedCitationFromRHP = createAction(
  '[Citations] Set deleted citation data from RHP',
  props<{ citationId: string }>()
);

export const setSelectedCommentsTabIndex = createAction(
  '[Comments] Set Comments tab index',
  props<{ index: number }>()
);
export const updateCitationsInRHPWithTrackchangeData = createAction(
  '[Citations] Update citations in RHP with track change data',
  props<{ citationStack: NumberedCitation[][]; undoStackIndex: number }>()
);

export const updateUnNumberedCitationsInRHPWithTrackchangeData = createAction(
  '[Citations] Update Unnumbered citations in RHP with track change data',
  props<{
    citationStack: UnnumberedCitation[][];
    unNumRefUndoStackIndex: number;
  }>()
);

export const updateUserPreferenceForTrackChangesView = createAction(
  '[Citations] Update User Preference for Track Changes View',
  props<{ userPreferenceForTrackChangesView: string }>()
);

export const loadDocumentAndContent = createAction(
  '[Document & Meta Data] Loading meta deta and document content',
  props<{ id: string; url: string }>()
);

export const loadDocumentAndContentComplete = createAction(
  '[Document & Meta Data] Loading Completed meta deta and document content',
  props<{
    citations: CitationModel;
    documentContent: string | null;
    trackChangeData: ITrackChange;
    subTemplates: WkTemplate[];
    keywords: any[];
  }>()
);

export const setDocumentValidationStatus = createAction(
  '[Validation] Set Validation Status',
  props<{
    documentValidationStatus: DocumentValidationStatus;
  }>()
);

export const resetDecoratorsState = createAction(
  '[Citation] Reset Decorator State'
);

export const setCMTitleValue = createAction(
  '[CM TITLE VALUE] Set CM Title Value',
  props<{ cmTitle: string }>()
);

export const setBaseHref = createAction(
  'Editor Component Base Href',
  props<{
    baseHrefForLinkPlugin: string;
    baseHrefPathUrl: string;
    baseHrefId: string;
  }>()
);
